var v = "5.8.1";
var fr = 29.9700012207031;
var ip = 0;
var op = 120.0000048877;
var w = 466;
var h = 466;
var nm = "BarChart orange";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "fader",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    226,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "bar 3",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    363.75,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: 0.667,
                                y: 1
                            },
                            o: {
                                x: 0.333,
                                y: 0
                            },
                            t: 31,
                            s: [
                                {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -62.467,
                                            71.531
                                        ],
                                        [
                                            -74.416,
                                            83.48
                                        ],
                                        [
                                            -74.737,
                                            83.48
                                        ],
                                        [
                                            -86.686,
                                            71.531
                                        ],
                                        [
                                            -86.872,
                                            70.729
                                        ],
                                        [
                                            -74.923,
                                            58.78
                                        ],
                                        [
                                            -74.602,
                                            58.78
                                        ],
                                        [
                                            -62.653,
                                            70.729
                                        ]
                                    ],
                                    c: true
                                }
                            ]
                        },
                        {
                            i: {
                                x: 0.1,
                                y: 1
                            },
                            o: {
                                x: 0.333,
                                y: 0
                            },
                            t: 33,
                            s: [
                                {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -44.967,
                                            71.531
                                        ],
                                        [
                                            -56.916,
                                            83.48
                                        ],
                                        [
                                            -74.737,
                                            83.48
                                        ],
                                        [
                                            -86.686,
                                            71.531
                                        ],
                                        [
                                            -86.872,
                                            70.729
                                        ],
                                        [
                                            -74.923,
                                            58.78
                                        ],
                                        [
                                            -57.102,
                                            58.78
                                        ],
                                        [
                                            -45.153,
                                            70.729
                                        ]
                                    ],
                                    c: true
                                }
                            ]
                        },
                        {
                            t: 43.0000017514259,
                            s: [
                                {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -44.967,
                                            71.531
                                        ],
                                        [
                                            -56.916,
                                            83.48
                                        ],
                                        [
                                            -74.737,
                                            83.48
                                        ],
                                        [
                                            -86.686,
                                            71.531
                                        ],
                                        [
                                            -86.805,
                                            -66.271
                                        ],
                                        [
                                            -74.856,
                                            -78.22
                                        ],
                                        [
                                            -57.035,
                                            -78.22
                                        ],
                                        [
                                            -45.086,
                                            -66.271
                                        ]
                                    ],
                                    c: true
                                }
                            ]
                        }
                    ],
                    ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
            },
            {
                ty: "fl",
                c: {
                    a: 0,
                    k: [
                        1,
                        0.658823529412,
                        0.462745098039,
                        1
                    ],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                bm: 0,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
            }
        ],
        ip: 25.0000010182709,
        op: 876.000035680211,
        st: -24.00000097754,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "bar 2",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    291.75,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: 0.667,
                                y: 1
                            },
                            o: {
                                x: 0.333,
                                y: 0
                            },
                            t: 25,
                            s: [
                                {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -61.967,
                                            71.531
                                        ],
                                        [
                                            -73.916,
                                            83.48
                                        ],
                                        [
                                            -74.737,
                                            83.48
                                        ],
                                        [
                                            -86.686,
                                            71.531
                                        ],
                                        [
                                            -86.872,
                                            70.729
                                        ],
                                        [
                                            -74.923,
                                            58.78
                                        ],
                                        [
                                            -74.102,
                                            58.78
                                        ],
                                        [
                                            -62.153,
                                            70.729
                                        ]
                                    ],
                                    c: true
                                }
                            ]
                        },
                        {
                            i: {
                                x: 0.1,
                                y: 1
                            },
                            o: {
                                x: 0.333,
                                y: 0
                            },
                            t: 27,
                            s: [
                                {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -44.967,
                                            71.531
                                        ],
                                        [
                                            -56.916,
                                            83.48
                                        ],
                                        [
                                            -74.737,
                                            83.48
                                        ],
                                        [
                                            -86.686,
                                            71.531
                                        ],
                                        [
                                            -86.872,
                                            70.729
                                        ],
                                        [
                                            -74.923,
                                            58.78
                                        ],
                                        [
                                            -57.102,
                                            58.78
                                        ],
                                        [
                                            -45.153,
                                            70.729
                                        ]
                                    ],
                                    c: true
                                }
                            ]
                        },
                        {
                            t: 36.0000014663101,
                            s: [
                                {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -44.967,
                                            71.531
                                        ],
                                        [
                                            -56.916,
                                            83.48
                                        ],
                                        [
                                            -74.737,
                                            83.48
                                        ],
                                        [
                                            -86.686,
                                            71.531
                                        ],
                                        [
                                            -86.653,
                                            -23.271
                                        ],
                                        [
                                            -74.704,
                                            -35.22
                                        ],
                                        [
                                            -56.882,
                                            -35.22
                                        ],
                                        [
                                            -44.933,
                                            -23.271
                                        ]
                                    ],
                                    c: true
                                }
                            ]
                        }
                    ],
                    ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
            },
            {
                ty: "fl",
                c: {
                    a: 0,
                    k: [
                        1,
                        0.658823529412,
                        0.462745098039,
                        1
                    ],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                bm: 0,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
            }
        ],
        ip: 20.0000008146167,
        op: 871.000035476557,
        st: -29.0000011811942,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "bar 1",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    220.25,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: 0.667,
                                y: 1
                            },
                            o: {
                                x: 0.333,
                                y: 0
                            },
                            t: 20,
                            s: [
                                {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -61.967,
                                            71.531
                                        ],
                                        [
                                            -73.916,
                                            83.48
                                        ],
                                        [
                                            -74.737,
                                            83.48
                                        ],
                                        [
                                            -86.686,
                                            71.531
                                        ],
                                        [
                                            -86.872,
                                            70.729
                                        ],
                                        [
                                            -74.923,
                                            58.78
                                        ],
                                        [
                                            -74.102,
                                            58.78
                                        ],
                                        [
                                            -62.153,
                                            70.729
                                        ]
                                    ],
                                    c: true
                                }
                            ]
                        },
                        {
                            i: {
                                x: 0.1,
                                y: 1
                            },
                            o: {
                                x: 0.333,
                                y: 0
                            },
                            t: 22,
                            s: [
                                {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -44.967,
                                            71.531
                                        ],
                                        [
                                            -56.916,
                                            83.48
                                        ],
                                        [
                                            -74.737,
                                            83.48
                                        ],
                                        [
                                            -86.686,
                                            71.531
                                        ],
                                        [
                                            -86.872,
                                            70.729
                                        ],
                                        [
                                            -74.923,
                                            58.78
                                        ],
                                        [
                                            -57.102,
                                            58.78
                                        ],
                                        [
                                            -45.153,
                                            70.729
                                        ]
                                    ],
                                    c: true
                                }
                            ]
                        },
                        {
                            t: 29.0000011811942,
                            s: [
                                {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -6.599
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.599,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -44.967,
                                            71.531
                                        ],
                                        [
                                            -56.916,
                                            83.48
                                        ],
                                        [
                                            -74.737,
                                            83.48
                                        ],
                                        [
                                            -86.686,
                                            71.531
                                        ],
                                        [
                                            -86.686,
                                            16.729
                                        ],
                                        [
                                            -74.737,
                                            4.78
                                        ],
                                        [
                                            -56.916,
                                            4.78
                                        ],
                                        [
                                            -44.967,
                                            16.729
                                        ]
                                    ],
                                    c: true
                                }
                            ]
                        }
                    ],
                    ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
            },
            {
                ty: "fl",
                c: {
                    a: 0,
                    k: [
                        1,
                        0.658823529412,
                        0.462745098039,
                        1
                    ],
                    ix: 4
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 5
                },
                r: 1,
                bm: 0,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
            }
        ],
        ip: 15.0000006109625,
        op: 866.000035272903,
        st: -34.0000013848484,
        bm: 0
    },
    {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "bgrnd",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.66
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 13.0000005295009,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    230.661,
                    231.706,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        127.026,
                                        0
                                    ],
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        -127.025,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        -127.025,
                                        0
                                    ],
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        127.026,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        230,
                                        0
                                    ],
                                    [
                                        0,
                                        230
                                    ],
                                    [
                                        -230,
                                        0
                                    ],
                                    [
                                        0,
                                        -230
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                1,
                                0.96862745098,
                                0.917647058824,
                                1
                            ],
                            ix: 4
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var BarChartOrange = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, BarChartOrange as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=BarChartOrange.json.es.js.map
